import React, { useContext } from 'react';
import { MandatoryChildren } from '../../../models/children-props';
import { useUserData } from '../../../hooks/useUserData';
import { OnboardingProvider } from '../states/OnboardingProvider';
import { AppContext } from '../../../providers/AppProvider';
import { useUserRole } from '../../../hooks/useUserRole';

export type OnboardingWrapperViewProps = MandatoryChildren<{
  //
}>;

export const OnboardingWrapperView = ({ children }: OnboardingWrapperViewProps): JSX.Element => {
  const { userData } = useUserData();
  const { selectedWorkspaceId } = useContext(AppContext);
  const { selectedOrgRole } = useUserRole();
  return userData && selectedWorkspaceId && selectedOrgRole ? (
    <OnboardingProvider me={userData} selectedOrgRole={selectedOrgRole} selectedWorkspaceId={selectedWorkspaceId}>
      {children}
    </OnboardingProvider>
  ) : (
    <>{children}</>
  );
};
